import * as z from "zod"

export const TenantModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
})
